<template>
  <div
    class="modal fade"
    id="contactInfoModal"
    data-focus="false"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <ValidationObserver
        ref="contactModal"
        class="modal-content"
        v-slot="{ handleSubmit }"
      >
        <div class="modal-header">
          <h5 class="modal-title">聯繫資訊</h5>
        </div>
        <div class="modal-body">
          <el-table
            class="mb-3"
            :data="contactHistory"
            :key="tableKey"
            style="width: 100%"
            stripe
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                {{ props.row.Remark }}
              </template>
            </el-table-column>
            <el-table-column
              label="職缺"
              prop="ManpowerDemandName"
              min-width="100"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="聯繫時間">
              <template slot-scope="scope">
                {{ $common.dateTimeFormatter(scope.row.ContactTime) }}
              </template>
            </el-table-column>
            <el-table-column label="邀約狀態">
              <template slot-scope="scope">
                {{ scope.row.ContactStatus.Name }}-{{
                  scope.row.ContactStatusSecond.Name
                }}
              </template>
            </el-table-column>
            <el-table-column label="聯繫人資">
              <template slot-scope="scope">
                {{ scope.row.CreateUserName }}
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="150px"
                  v-model="delPopover[scope.$index]"
                >
                  <p>確認刪除？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      size="mini"
                      type="text"
                      @click="cancel(scope.$index)"
                    >
                      取消
                    </el-button>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="delRecord(scope.row.Id, scope.$index)"
                    >
                      確定
                    </el-button>
                  </div>
                  <el-button slot="reference">删除</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div class="form-group form-inline">
            <label for="">職缺</label>
            <el-select
              class="w-100"
              filterable
              clearable
              value-key="ManpowerDemandNo"
              placeholder="請選擇"
              v-model="contact.ManpowerDemandNo"
            >
              <el-option
                v-for="opening in openingOptions"
                :key="opening.ManpowerDemandNo"
                :label="opening.ManpowerDemandName"
                :value="opening.ManpowerDemandNo"
              >
              </el-option>
            </el-select>
          </div>

          <div class="form-group form-inline">
            <label for=""><span class="mark">*</span>聯繫時間</label>
            <ValidationProvider
              class="w-100"
              rules="required"
              name="聯繫時間"
              v-slot="{ errors }"
            >
              <el-date-picker
                class="w-100"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="{
                  disabledDate: $common.disabledTimeAfterNowTime,
                }"
                default-time="08:00:00"
                placeholder="請選擇日期時間"
                v-model="contact.ContactTime"
              />
              <span class="text-danger" style="font-size: 13px">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <div class="form-group form-inline">
            <label for=""><span class="mark">*</span>聯繫狀態</label>
            <ValidationProvider
              class="w-100"
              rules="required"
              name="聯繫狀態"
              v-slot="{ errors }"
            >
              <el-cascader
                class="w-100"
                :options="contactOptions"
                clearable
                :show-all-levels="true"
                placeholder="請選擇"
                v-model="contact.ContactStatusForFront"
              />
              <span class="text-danger" style="font-size: 13px">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="form-group form-inline">
            <label for="">備註</label>
            <el-input
              class="w-100"
              type="textarea"
              :rows="4"
              maxlength="200"
              show-word-limit
              v-model="contact.Remark"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            關閉
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="handleSubmit(saveRecord)"
          >
            儲存
          </button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["personData"],

  name: "ContactInfoModal",
  data() {
    return {
      contact: {},

      // 刪除提示框
      delPopover: [],

      tableKey: 0,
      contactHistory: [],

      // 聯繫狀態
      contactOptions: [],
      // 職缺
      openingOptions: [],
    };
  },

  computed: {
    ...mapGetters(["showContactInfo"]),
  },

  watch: {
    showContactInfo: async function (e) {
      if (e) {
        this.contact = {
          ManpowerDemandNo: this.personData.ManpowerDemandNo,
        };
        this.$refs.contactModal.reset();
        await this.getRecord();
        await $("#contactInfoModal").modal("show");
      } else {
        $("#contactInfoModal").modal("hide");
      }
    },
  },

  methods: {
    // 儲存 履歷聯繫紀錄
    saveRecord() {
      this.updateLoading(true);
      this.$api.contactRecord
        .postContactRecord({
          ResumeId: this.personData.ResumeId,
          ...this.contact,
          ContactStatus: {
            Guid:
              this.contact.ContactStatusForFront.length > 0
                ? this.contact.ContactStatusForFront[0]
                : null,
          },
          ContactStatusSecond: {
            Guid:
              this.contact.ContactStatusForFront.length > 0
                ? this.contact.ContactStatusForFront[1]
                : null,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.contact = {
              ManpowerDemandNo: this.personData.ManpowerDemandNo,
            };
            this.$refs.contactModal.reset();
            this.$notify({
              title: "成功",
              message: "新增成功",
              type: "success",
              duration: 2500,
            });
            this.getRecord();
          }
          this.updateLoading(false);
        });
    },

    // 取得 履歷聯繫紀錄
    getRecord() {
      this.updateLoading(true);
      this.$api.contactRecord
        .getContactRecord(this.personData.ResumeId)
        .then((response) => {
          if (response.status === 200) {
            this.contactHistory = response.data;

            this.tableKey += 1;
          }
          this.updateLoading(false);
        });
    },

    // 取消 刪除聯繫資訊
    cancel(index) {
      this.$set(this.delPopover, index, false);
    },

    // 刪除 聯繫資訊
    delRecord(recordId, index) {
      this.$set(this.delPopover, index, false);
      this.updateLoading(true);
      this.$api.contactRecord.deleteContactRecord(recordId).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2500,
          });
          this.getRecord();
        }
        this.updateLoading(false);
      });
    },

    // 關閉 Modal
    closeModal() {
      this.$store.commit("OpenContactInfoModal", false);
    },

    async getData() {
      try {
        // 取得 聯繫狀態
        const status = await this.$api.contactRecord.getContactStatus(false);

        this.contactOptions = status.data.map((item) => {
          return {
            value: item.Guid,
            label: item.Name,
            children: item.Children.map((children) => {
              return {
                value: children.Guid,
                label: children.Name,
              };
            }),
          };
        });
        // 取得 職缺
        const opening = await this.$api.opening.getOpening();
        this.openingOptions = opening.data.map((item) => {
          return {
            ManpowerDemandNo: item.ManpowerDemandNo,
            ManpowerDemandName: item.ManpowerDemandName,
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$store.commit("OpenContactInfoModal", false);
  },
};
</script>
